<template>
  <div class="d-flex flex-column flex h100">
    <navbar></navbar>
    <div class="app">
      <div id="content" class="app-content box-shadow-3 scroll-x">
        <!-- Optional navbar at top of page -->
        <div class="navbar navbar-light bg-light b-b">
          <div class="flex navbar-breadcrumbs">
            <a v-if="classObj && student" class="text-muted" :href="`/#/class/${classObj.id}`">
              {{
              classObj.name
              }}
            </a>
            <i v-if="classObj && student" class="far fa-fw fa-angle-right text-muted" />
            <span v-if="classObj && student">{{ student.full_name }}</span>
            <i v-if="classObj && student" class="far fa-fw fa-angle-right text-muted" />
            <span v-if="classObj && student">Student Results</span>
            <span v-if="!(classObj && student)">
              <loading type="inline-header" />
            </span>
          </div>
			<button
			v-if="!all_results"
            class="btn btn-sm theme float-right mr-3"
            title="Show results in all classes"
			@click="showAllResults()"
          > Show All Results
          </button>
		<button
		v-if="all_results"
            class="btn btn-sm theme float-right mr-3"
            title="Show results in this classes"
			@click="showLessResults()"
          > Show Class Results
          </button>
          <button
            v-if="classObj && student && results.length > 0 && !showingAllDetails"
            class="btn btn-icon btn-sm theme float-right mr-3"
            v-tippy
            title="Show All Details"
            @click="showAllDetails()"
          >
            <i class="fas fa-plus" />
          </button>
          <button
            v-if="classObj && student && results.length > 0 && showingAllDetails"
            class="btn btn-icon btn-sm theme float-right mr-3"
            v-tippy
            title="Hide All Details"
            @click="hideAllDetails()"
          >
            <i class="fas fa-minus" />
          </button>

          <a
            v-if="classObj && student"
            class="btn-nav-topright b-l ml-0"
            @click="print()"
            v-tippy
            title="Print"
          >
            <div>
              <i class="fas fa-print fa-lg fa-fw" />
            </div>
          </a>
          <a v-if="classObj && student" class="btn-nav-topright b-l ml-0" @click="$router.go(-1)">
            <div>
              <i class="fas fa-arrow-alt-left fa-fw" />
              Back
            </div>
          </a>
          <a class="btn-nav-topright b-l ml-0" href="/#/landing">
            <div>
              <i class="fas fa-th-large fa-fw" />
              Home
            </div>
          </a>
        </div>

        <div class="content-main">
          <div v-for="(result, i) in results" :key="i" class="d-flex flex-row card box m-3">
            <div v-if="result.showDetails" class="flex" style="margin-bottom: 20px;">
              <media :response="result.response"></media>
            </div>
            <div v-if="result.showDetails" class="side-panel px-2">
              <div class="box mb-3">
                <button
                  class="btn btn-icon btn-sm theme float-right mt-3 mr-3"
                  v-tippy
                  title="Hide Details"
                  @click="hideDetails(result)"
                >
                  <i class="fas fa-minus" />
                </button>
                <h4 class="px-3 pt-3">{{ result.assessment_name }}</h4>
                <div class="px-3 pb-3 text-muted text-md">{{ result.response.delivery_name}}</div>
                <div class="px-3 pt-3 text-muted text-md">{{ result.response.class_name }}</div>

              </div>
              <multi-score :scores="result.response.scores" :rubric="result.rubric" class="mb-3"></multi-score>
              <template v-for="score in result.response.scores">
                <div
                  class="px-4 py-2 box w-100 mb-3 feedback-box"
                  :key="score.id"
                  v-if="score.student_feedback"
                >
                  <i
                    v-if="scoreTypeIconClass(score.score_type)"
                    class="fas fa-lg"
                    :class="scoreTypeIconClass(score.score_type)"
                    v-tippy
                    :title="scoreTypeTooltip(score, score.score_type)"
                  ></i>
                  <i
                    v-if="!scoreTypeIconClass(score.score_type)"
                    class="material-icons"
                    style="font-size: 28px; line-height: 30px;"
                    v-tippy
                    :title="scoreTypeTooltip(firstScore)"
                  >{{ scoreTypeIcon(score.score_type) }}</i>
                  <strong>Feedback:</strong>
                  <div v-html="score.student_feedback"></div>
                </div>
              </template>
              <div
                class="px-4 pb-2 text-center box w-100 mb-2"
                v-if="result.response.weightedScore"
              >
                <div class="text-xl">{{ result.response.weightedScore }}</div>
                <div class="text-muted">Final</div>
              </div>
              <div
                class="px-4 py-2 text-center box w-100 mb-2"
                v-if="!result.response.weightedScore"
              >
                <div class="text-muted">Scoring Not Complete</div>
              </div>
            </div>

            <div v-if="!result.showDetails" class="d-flex flex-row align-items-center w-100">
              <div class="flex">
                <h4 class="px-3 pt-3">{{ result.assessment_name }}</h4>
                <div class="px-3 pb-3 text-muted text-md">{{ result.response.delivery_name}}</div>
                <h2 class="px-3 pt-3 text-muted text-md">{{ result.response.class_name }}</h2>

              </div>
              <div class="pr-3 align-self-start" style="padding-top: 18px;">
<p>                <button
                  class="btn btn-icon btn-sm theme"
                  v-tippy
                  title="Show Details"
                  @click="showDetails(result)"
                >
                  <i class="fas fa-plus" />
                </button>
                </p>
<p v-if="result.response.archived_time">                <button
                  class="btn btn-icon btn-sm"
                  v-tippy
                  :title="archive_message + format(result.response.archived_time)"
                >
                  <i class="fas fa-archive fa-lg fa-fw" />
                </button></p>
              </div>
              
              <div class="h-100 b-l d-flex flex-column justify-content-center">
                <div
                  class="px-4 text-center"
                  style="width: 96px"
                  v-if="result.response.weightedScore"
                >
                  <div class="text-xl">{{ result.response.weightedScore }}</div>
                  <div class="text-muted">Final</div>
                </div>
                <div
                  class="px-2 text-center"
                  style="width: 96px"
                  v-if="!result.response.weightedScore && result.response.scores.length > 0"
                >
                  <div class="text-muted">Not Complete</div>
                </div>
                <div
                  class="px-2 text-center"
                  style="width: 96px"
                  v-if="!result.response.weightedScore && result.response.scores.length === 0"
                >
                  <div class="text-muted">No Score</div>
                </div>
              </div>
            </div>
          </div>

          <div v-if="classObj && student && results.length == 0" class="text-center">
            <h1 class="text-extra-muted mt-5">No student work</h1>
          </div>
        </div>
      </div>
    </div>

    <mzfooter></mzfooter>
  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.side-panel {
  width: 460px;
  margin-top: 20px;
}
.text-xl {
  font-size: 2rem;
}
</style>

<script>
import moment from "moment";

import ClassService from "@/services/ClassService";
import StudentService from "@/services/StudentService";
import AssessmentService from "@/services/AssessmentService";
import Media from "@/components/viewer/Media";
import MultiScore from "@/components/MultiScore";
import Notie from "@/services/NotieService";
import draggable from "vuedraggable";
import fs from "@/services/FormatService";
import store from "@/services/Store";
import BB from "bluebird";
import $ from "jquery";

export default {
  name: "StudentResults",

  props: ["user"],

  data() {
    return {
      fs: fs,
      assessment: null,
      item: null,
      deliveryID: null,
      rubric: null,
      classObj: null,
	  student: null,
	  tempresults :[],
      results: [],
	allResults : [],
	  workStats: null,
    all_results:false,
    archive_message :"This response was archived in: "
    };
  },
  components: { draggable, Media, MultiScore },
  watch: {},
  computed: {
    showingAllDetails() {
      return _.every(this.results, result => {
        return result.showDetails;
      });
    }
  },
  created() {
    this.deliveryID = this.$route.query.d;
    this.loadData();
  },
  methods: {
    loadData() {
      let classID = this.$route.params.classID;
      let studentID = this.$route.params.studentID;
      return BB.props({
        class: ClassService.getClassAndAssessments(classID),
        student: StudentService.getStudent(studentID),
		results: ClassService.getStudentResults(classID, studentID),
		allResults:ClassService.getAllStudentResults(studentID)
      })
        .then(resps => {
          this.classObj = resps.class.data.class;
          this.student = resps.student.data;
		  this.results = resps.results.data.results;
      this.allResults = resps.allResults.data.results;
      var i;
      for (i = 0; i < this.allResults.length; i++) {
        this.allResults[i].delivery_name=this.allResults[i].response.delivery_name
      }
      console.log("all results",resps.allResults.data.results)
          _.each(this.results, result => {
            result.response.weightedScore = this.getFinalScore(result);
		  });
          _.each(this.allResults, result => {
            result.response.weightedScore = this.getFinalScore(result);
		  });
		  this.tempresults = this.results
        })
        .catch(err => {
          console.log(err);
          Notie.error("Failed to load student work", err);
        });
    },

    progressIcon(delta) {
      if (delta < 0) {
        return "fa-chevron-down";
      } else if (delta > 0) {
        return "fa-chevron-up";
      } else {
        return "";
      }
    },

    progressClass(delta) {
      if (delta == undefined) {
        return "";
      }

      if (delta < 0) {
        return "text-danger";
      } else if (delta > 0) {
        return "text-success";
      } else {
        return "text-warning";
      }
    },
showAllResults(){
	this.all_results = !this.all_results;
	this.results = this.allResults
},
  format(date) {
    return moment(date).format("M/D/YY h:mm:ss a");
  },
showLessResults(){
	this.all_results = !this.all_results;

	this.results = this.tempresults
},
    scoreTypeIcon(scoreType) {
      return fs.scoreTypeIcon(scoreType);
    },
    scoreTypeIconClass(scoreType) {
      return fs.scoreTypeIconClass(scoreType);
    },
    scoreTypeStr(scoreType) {
      let ret = fs.scoreTypeName(scoreType);
      if (this.hasUser) {
        return `${ret}:`;
      } else {
        return ret;
      }
    },
    scoreTypeTooltip(score, scoreType) {
      let tooltip = `<strong>${this.scoreTypeStr(scoreType)} Score</strong>`;
      if (score) {
        tooltip += `<br /><span class="text-muted"><i class="fal fa-clock"></i> ${fs.fullDate(
          score.created_at
        )}</span>`;
      } else {
        tooltip += `<br /><span class="text-muted">Not yet applied</span>`;
      }

      return tooltip;
    },
    getTraitName(traitID) {
      let trait = _.find(this.rubric.traits, { id: traitID });
      if (trait) {
        return trait.name;
      } else {
        return "?";
      }
    },

    openScore(response) {
      if (!response.media || response.media.length == 0) {
        return;
      }

      let aid = response.assessment_id;
      let iid = response.item_id;
      let cid = response.class_id;
      let did = response.delivery_id;
      let rid = response.id;
      ViewingDriver.enter(this, aid, iid, rid);
    },

    getDeliveryName(result) {
      let delivery = _.find(this.classObj.deliveries, {
        id: result.response.delivery_id
      });
      if (!delivery || !delivery.name) {
        return "Unknown";
      }
      return delivery.name;
    },

    getFinalScore(result) {
      if (result.response.state != 10) {
        return null;
      }

      let res_score = _.find(result.response.scores, { score_type: 3 });
      if (res_score) {
        return this.getWeightedScore(res_score, result.rubric);
      }

      let second_score = _.find(result.response.scores, {
        score_type: 2
      });
      if (second_score) {
        return this.getWeightedScore(second_score, result.rubric);
      }

      let first_score = _.find(result.response.scores, {
        score_type: 1
      });
      if (first_score) {
        return this.getWeightedScore(first_score, result.rubric);
      }

      return null;
    },

    getWeightedScore(score, rubric) {
      let unweighted = _.every(rubric.traits, {
        weight: 0
      });

      let weighted_score = 0;
      _.each(score.trait_scores, ts => {
        if (unweighted) {
          weighted_score += ts.score;
        } else {
          let trait = _.find(rubric.traits, {
            id: ts.trait_id
          });
          weighted_score += ts.score * trait.weight;
        }
      });

      return weighted_score;
    },

    showDetails(result) {
      this.$set(result, "showDetails", true);
    },

    showAllDetails() {
      _.each(this.results, result => {
        this.showDetails(result);
      });
    },

    hideDetails(result) {
      this.$set(result, "showDetails", false);
    },

    hideAllDetails() {
      _.each(this.results, result => {
        this.hideDetails(result);
      });
    },

    print() {
      let cid = this.classObj.id;
      let sid = this.student.id;
      var windowRef = window.open();
      windowRef.location = `/#/class/${cid}/student/${sid}/results/print`;
    }
  }
};
</script>





// WEBPACK FOOTER //
// src/vues/Classes/StudentResults.vue